import { app, faq } from '@getpopsure/private-constants';
import { illustrations } from '@popsure/dirty-swan';
import { TFunction } from 'next-i18next';

export interface SupportOptions {
  linkType: 'generic' | 'intercom';
  genericURL?: string;
  title: string;
  description: string;
  imgSrc: string;
  imgAlt: string;
}

export const getSupportByCountry = (
  t: TFunction
): Record<string, SupportOptions[]> => {
  return {
    de: [
      {
        linkType: 'intercom',
        title: t('page.support.tile.intercom.title'),
        description: t('page.support.tile.intercom.description'),
        imgSrc: illustrations.mail,
        imgAlt: t('page.support.tile.intercom.image.alt'),
      },
      {
        linkType: 'generic',
        genericURL: app.recommendationTool,
        title: t('page.support.tile.recommendationTool.title'),
        description: t('page.support.tile.recommendationTool.description'),
        imgSrc: illustrations.allInOneAccount,
        imgAlt: t('page.support.tile.recommendationTool.image.alt'),
      },
      {
        linkType: 'generic',
        genericURL: faq.base,
        title: t('page.support.tile.faq.title'),
        description: t('page.support.tile.faq.description'),
        imgSrc: illustrations.bookOpen,
        imgAlt: t('page.support.tile.faq.image.alt'),
      },
    ],
    es: [
      {
        linkType: 'intercom',
        title: t('page.support.tile.intercom.title'),
        description: t('page.support.tile.intercom.description'),
        imgSrc: illustrations.mail,
        imgAlt: t('page.support.tile.intercom.image.alt'),
      },
      {
        linkType: 'generic',
        genericURL: faq.baseEs,
        title: t('page.support.tile.faq.title'),
        description: t('page.support.tile.faq.description'),
        imgSrc: illustrations.bookOpen,
        imgAlt: t('page.support.tile.faq.image.alt'),
      },
    ],
    fr: [
      {
        linkType: 'intercom',
        title: t('page.support.tile.intercom.title'),
        description: t('page.support.tile.intercom.description'),
        imgSrc: illustrations.mail,
        imgAlt: t('page.support.tile.intercom.image.alt'),
      },
    ],
    eu: [
      {
        linkType: 'intercom',
        title: t('page.support.tile.intercom.title'),
        description: t('page.support.tile.intercom.description'),
        imgSrc: illustrations.mail,
        imgAlt: t('page.support.tile.intercom.image.alt'),
      },
      {
        linkType: 'generic',
        genericURL: faq.baseEu,
        title: t('page.support.tile.faq.title'),
        description: t('page.support.tile.faq.description'),
        imgSrc: illustrations.bookOpen,
        imgAlt: t('page.support.tile.faq.image.alt'),
      },
    ],
  };
};
